module.exports = __webpack_public_path__ + "static/img/jxhd-4.75b93992.png";